<template>
    <div id="app">
        <Header/>
        <div class="main">
            <router-view></router-view>
        </div>
        <Footer/>
    </div>
</template>

<script>
import "./assets/css/reset.min.css"
import "./assets/js/rem"
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import { mapState } from 'vuex';
export default {
    name: 'app',
    data() {
        return {};
    },
    metaInfo() {
        return {
            title: this.$i18n.locale == 'en' ? this.metaInfo.title_en : this.metaInfo.title,
            meta: [
                {
                    name: 'keywords',
                    content: this.$i18n.locale == 'en' ? this.metaInfo.keywords_en : this.metaInfo.keywords,
                },
                {
                    name: 'description',
                    content: this.$i18n.locale == 'en' ? this.metaInfo.description_en : this.metaInfo.description,
                },
            ]
        };
    },
    computed: {
        ...mapState(['metaInfo']),
    },
    components: {
        Header,
        Footer
    },
    mounted() {
        // seo 搜索引擎关键字，描述
        this.$store.dispatch('getSeo');
        // 如果token存在，判断是否有效
        if (localStorage.getItem('token')) { 
            this.$store.dispatch('getUserinfo');
        }
    },
}
</script>

<style lang="scss">
:root{
    --font_color: #333;
    --home_bg: #1a1a1a;
    --body_bg: #efefed;
}
#app{
    font-size: .3rem;
    color: var(--font_color);
    font-family:Arial,Helvetica,sans-serif;
}
input,
textarea{
    font-family:Arial,Helvetica,sans-serif;
}
.only_pc{
    @media only screen and (max-width: 750px) {
        display: none !important;
    }
}
.only_mobile{
    // display: none !important;
    @media only screen and (min-width: 750px) {
        display: none !important;
    }
}
.layout_body{
    background: var(--body_bg);
    padding-bottom: 1rem;
    @media only screen and (max-width: 750px) {
        background: #fff;
        padding-bottom: 0;
    }
}
.layout_main{
    width: 12rem;
    margin: 0 auto;
    @media only screen and (max-width: 750px) {
        width: 6.9rem;
    }
}
.layout_content{
    background: #fff;
    padding: .4rem;
    margin-bottom: .6rem;
    &:first-child{
        margin-top: -1.7rem;
    }
    &:last-child{
        margin-bottom: 0;
    }
    @media only screen and (max-width: 750px) {
        padding: .3rem;
        border-top: 1px solid #999;
        margin-bottom: 0;
        &:first-child{
            margin-top: 0;
            border-top: none;
        }
    }
}
.layout_bg{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.layout_flex_center{
    display: flex;
    justify-content: center;
    align-items: center;
}
.layout_mine{
    min-height: 60vh;
    padding: 1rem 0;
    @media only screen and (max-width: 750px) {
        min-height: 65vh;
    }
}
.position_100{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.position_center{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    &.left{
        left: 0;
        transform: translate(0, -50%);
    }
}
.text_shadow{
    text-shadow: 0 .04rem .12rem rgba($color: #0d0d0d, $alpha: 1);
    @media only screen and (max-width: 750px) {
        text-shadow: 0 0 .2rem rgba($color: #000, $alpha: 1), 0 0 .2rem rgba($color: #000, $alpha: .5);
    }
}
.flex{
    display: flex;
}
.flex_wrap{
    flex-wrap: wrap;
}
.flex_column{
    flex-direction: column;
}
.justify_center{
    justify-content: center;
}
.justify_between{
    justify-content: space-between;
}
.justify_evenly{
    justify-content: space-evenly;
}
.justify_end{
    justify-content: flex-end;
}
.align_start{
    align-items: flex-start;
}
.align_center{
    align-items: center;
}
.align_end{
    align-items: flex-end;
}
.col2{
    width: 50%;
}
input,
textarea{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    border: none;
    border-radius: 0;
    display: block;
    background: none;
    outline: none;
    resize: none;
    color: var(--font_color);
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}
// input[type='number'] {
//     -moz-appearance: textfield;
// }
textarea{
    line-height: 1.2;
}
.layout_btn_more{
    cursor: pointer;
    font-size: .18rem;
    color: #999;
    margin-top: .3rem;
    @media only screen and (max-width: 750px) {
        font-size: .26rem;
    }
}
.no_more{
    font-size: .2rem;
    color: #999;
    margin: .5rem auto 0;
    text-align: center;
    @media only screen and (max-width: 750px) {
        font-size: .26rem;
    }
}
</style>
